import { createSlice } from "@reduxjs/toolkit";

interface State {
    isError: boolean,
    errorMessage: string
}
interface Action {
    type: string,
    payload: State
}

const errorSlice = createSlice({
    name: "ErrorSlice",
    initialState: {
        isError: false,
        errorMessage: ''
    },
    reducers: {
        setError(state: State, action: Action) {
            state.isError = action.payload.isError
            state.errorMessage = action.payload.errorMessage
        },
        clearError: (state) => {
            state.isError = false;
            state.errorMessage = '';
        }
    }
});

export const { setError,clearError } = errorSlice.actions;
export default errorSlice.reducer;